module.exports = __webpack_public_path__ + "static/img/abimg4.b691eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/abimg4.png
// module id = WuzD
// module chunks = 1